import type { ReactElement } from 'react';

export default function Dollar(): ReactElement {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Automated migration to Biome
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.166 2.65625V21.3438'
        stroke='#0065C1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.1973 8.40625C17.1973 7.93431 17.1043 7.467 16.9237 7.03098C16.7431 6.59497 16.4784 6.1988 16.1447 5.86509C15.811 5.53137 15.4148 5.26666 14.9788 5.08606C14.5428 4.90546 14.0755 4.8125 13.6035 4.8125H10.3691C9.41602 4.8125 8.50193 5.19113 7.82798 5.86509C7.15402 6.53904 6.77539 7.45313 6.77539 8.40625C6.77539 9.35937 7.15402 10.2735 7.82798 10.9474C8.50193 11.6214 9.41602 12 10.3691 12H14.3223C15.2754 12 16.1895 12.3786 16.8634 13.0526C17.5374 13.7265 17.916 14.6406 17.916 15.5938C17.916 16.5469 17.5374 17.461 16.8634 18.1349C16.1895 18.8089 15.2754 19.1875 14.3223 19.1875H10.0098C9.05664 19.1875 8.14256 18.8089 7.4686 18.1349C6.79464 17.461 6.41602 16.5469 6.41602 15.5938'
        stroke='#0065C1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
